import {makeAutoObservable} from "mobx";

class HomeLazyLoadStore {

    map = new Map([
        [1, false],
        [2, false],
        [3, false],
        [4, false],
        [5, false],
        [6, false],
    ])
    curIndex = 0;

    get size(){
        return this.map.size
    }

    startLoadNext() {
        this.curIndex = this.curIndex + 1

        if(this.curIndex > this.size){
            return;
        }
        this.map.set(this.curIndex, true)
    }

    get adv1Flag() {
        return this.map.get(1)
    }

    get selfFloorFlag() {
        return this.map.get(2)
    }

    get adv2Flag() {
        return this.map.get(3)
    }

    get floorFlag() {
        return this.map.get(4)
    }

    get guessYouLikeFlag() {
        return this.map.get(5)
    }

    get lookAroundFlag() {
        return this.map.get(6)
    }

    constructor() {
        makeAutoObservable(this)
    }
}

export default HomeLazyLoadStore